import React from 'react';
import { ReactComponent as Logo } from './logo.svg'

export default ({ height = 50, width = 150, style={}, ...props }) => <div {...props} style={{ height, width, ...style }}><Logo style={{ fill: '#FE0072' }} /></div>